import { TFunction } from 'i18next'

import { IntegrationStatus } from '@features/bills/types/integrationStatus'
import { cegidIntegrationRejectionCodeToTooltipTranslationKeys } from '@features/cegidIntegration/constants/cegidIntegrationStatusToTranslationKeys'
import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
const syncStatusToDisabledReason: Record<CegidIntegrationStatus, string> = {
  [CegidIntegrationStatus.Pending]: 'This document is being sent to your accountant and cannot be voided.',
  [CegidIntegrationStatus.Processing]: 'This document is being sent to your accountant and cannot be voided.',
  [CegidIntegrationStatus.Posted]: 'This document is synced with your accountant and cannot be voided.',
  [CegidIntegrationStatus.Failed]:
    'This document had an unknown error while syncing with your accountant and cannot be voided.',
}

export const getVoidBillDisabledReason = (
  syncStatus: IntegrationStatus | null | undefined,
  t: TFunction,
): string | null => {
  if (!syncStatus) {
    return null
  }

  const { status, rejectCode } = syncStatus
  const reason = syncStatusToDisabledReason[status]

  if (status !== CegidIntegrationStatus.Failed) {
    return reason
  }

  // Run-time safety check for unknown reject codes
  const rejectDescriptionKey = rejectCode && cegidIntegrationRejectionCodeToTooltipTranslationKeys[rejectCode]

  return rejectDescriptionKey ? t(rejectDescriptionKey) : syncStatusToDisabledReason[CegidIntegrationStatus.Failed]
}
